import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/profile/user-2.jpg")